<template>
    <button type="button" id="btn-back" class="btn btn-danger btn--xl" @click="cancel">{{ $t('labels.back') }}</button>
</template>

<script>
import {writeTrackLog} from "../../utils/tracking";

export default {
  props: ['redirect', 'clearActivity'],

  methods: {
    goBack(e) {
      e.preventDefault();
      e.stopPropagation();

      if (process.env.NODE_ENV === 'development') console.log('Go back: route', this.$route);

      if (this.$route.name !== 'login' && this.$route.name !== 'pin') this.cancel()
    },

    cancel() {
      const currentActivity = this.$store.getters.currentActivityForEmployee;

      if (this.$store.state.enableTracking) writeTrackLog('Cancel activity' + JSON.stringify({
        activity: currentActivity,
        redirect: this.redirect,
        clear: this.clearActivity
      }));

      if (this.clearActivity && currentActivity) this.$store.dispatch('cancelActivity', currentActivity.id);

      if (this.redirect === undefined || this.redirect === null) {
        if (this.$route.name === 'activity' || this.$route.name === 'workday' || this.$route.name === 'break') {
          this.$store.dispatch('clearCurrentEmployee');
          return this.$router.push('pin');
        }

        return this.$router.go(-1);
      }

      return this.$router.push(this.redirect);
    }
  },

  mounted() {
    document.addEventListener('backbutton', this.goBack, false)
  },

  beforeDestroy() {
    document.removeEventListener('backbutton', this.goBack)
  }
}
</script>
